import Agreement from './Agreement';
import Text from './Text';

export default Agreement;
export { Text };
